// Bounded offline session: identity cached after a SUCCESSFUL online auth; reusable for 12h on the same device/register.
// No passwords, PINs or tokens are stored here (the JWT stays where it always was). Cleared on logout.
import { openDB, putConfig, getConfig } from "./db";

export const OFFLINE_SESSION_MS = 12 * 60 * 60 * 1000;
export const regKey = () => (localStorage.getItem("neec_register_token") || localStorage.getItem("neec_device_token") || "device").slice(0, 16);
const SESSION_DB = () => openDB("session", "device"); // device-level pointer to the tenant DB; holds no business data

export async function cacheOfflineSession(user) {
  if (!user || user.role === "superadmin") return;
  const db = await SESSION_DB();
  await putConfig(db, "last_auth", { user_id: user.id, tenant: user.business_id, name: user.name, role: user.role, email: user.email, authed_at: new Date().toISOString(), register_key: regKey() });
}

export async function restoreOfflineSession() {
  const db = await SESSION_DB(); const last = await getConfig(db, "last_auth");
  if (!last || Date.now() - new Date(last.authed_at).getTime() > OFFLINE_SESSION_MS) return null;
  const tdb = await openDB(last.tenant, regKey());
  const ident = await getConfig(tdb, "identity");
  if (!ident || ident.user_id !== last.user_id || !ident.shift_id) return null; // needs cached identity + open shift
  const user = { id: last.user_id, business_id: last.tenant, name: last.name, role: last.role, email: last.email, offline_session: true };
  const business = { id: last.tenant, name: ident.business_name, tax_rate: ident.tax_rate, currency: ident.currency, offline_snapshot: true, show_recent_sales: false, service_details_reviewed: true, onboarded: true, features: ident.features || {} };
  return { user, business };
}

export async function clearOfflineSession() {
  try { const db = await SESSION_DB(); await putConfig(db, "last_auth", { cleared: true, authed_at: "1970-01-01T00:00:00Z" }); } catch { /* ignore */ }
}
